<template>
    <div class="container">
        <img class="img" src="https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=1981526287,546163107&fm=26&gp=0.jpg" alt="">
        <div class="article-info">
            <div class="title">
                Redshift V2.6.41-从入门到精通全面深入教学…
            </div>
            <div class="articleDesc" >
                 <span v-if="linkFrom !='space'">2021-12-13 </span>
                 <span v-else>12-13 </span>
                 <span style="float:right" v-if="collection !=='caogaoxiang'">
                    <span class="iconStyle">
                        <i class="el-icon-star-on"></i>
                        <span style="padding-left:1px">150</span>
                    </span>
                    <span class="iconStyle">
                        <i class="el-icon-view"></i> 
                        <span style="padding-left:2px">500</span>
                    </span>
                    
                    <span class="iconStyle">
                        <span class="iconfont" >&#xe62e;</span>
                        <span style="padding-left:1px">300</span>
                    </span>
                 </span>
                 <span v-else>
                    <span class="tool" style="float:right;font-family: PingFangSC-Regular, PingFang SC;">删除 </span> 
                    <span class="tool" style="float:right;padding:0 10px;font-family: PingFangSC-Regular, PingFang SC;">编辑 </span>
                 </span>
             </div>
            
            
            <div class="toolDiv" v-if="collection ==='collection'">
                <div class="tool"><i class="el-icon-star-on" style="font-size:18px;vertical-align: top;" ></i>取消收藏</div>
                
            </div>

            <div class="toolDiv" v-else-if="collection==='manager' && linkFrom !='space'">
                <span class="tool" style="float:right">删除 </span> 
                <span class="tool" style="float:right;padding:0 10px;">编辑 </span>
                <span class="tool" style="float:right">查看评论 </span> 
                <!-- <span class="tool" style="float:left">
                    <img style="vertical-align: middle;margin-right:5px;width:12px;height:12px" src="@/assets/icons/delete.png" />删除</span>
                <span class="tool" style="float:right">
                    <img style="vertical-align: middle;margin-right:5px;width:12px;height:12px" src="@/assets/icons/iconfontzhizuobiaozhunbduan10.png" />编辑 </span>
             -->
            </div>
            <div  v-else>
            </div>

            
        </div>
         
    </div>
</template>
<script>
export default {
  name: 'ManagerArticleV',
  components: {

  },
  props: {
    collection:{
      type:String,
      default:'',
    },
    linkFrom:{
      type:String,
      default:'',
    }
    
  },
  data() {
    return {
      
    }
  }
}
</script>
<style lang="stylus" scoped>
    .container
        width 96%;
        background white;
        border-radius 4px;
        cursor pointer;
        padding:10px 0 0px 0;
        
        .img
            width 100%;
            height 116px;
            border-radius 4px 4px 0px 0px;
        .article-info
            // padding 14px;
            margin-top:-5px;
            padding:15px 10px;
            background :#f4f4f5;
            .title
                font-size: 14px;
                font-weight: 400;
                color: #999999;
                line-height: 20px;
                text-align:left;
            .articleDesc
                font-size: 12px;
                font-weight: 400;
                color: #B8B9BA;
                line-height: 17px;
                margin-top 20px;
                text-align :left;
                .iconStyle{
                    padding:0 3px;
                }
            .info
                display flex;
                align-items center;
                justify-content space-between;
                padding 10px 0px 10px 0;
                .img
                    width: 28px;
                    height: 28px;
                    border-radius 50px;
.toolDiv{
    background: #fff;
    padding-bottom:15px;
    margin-top:10px;
    background :#f4f4f5;
    width:100%;
    .tool{
        padding-right:3px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #b8b9ba;
        line-height: 20px;
        height :20px;
    }
}        
</style>